import styled from '@emotion/styled';

export const Container = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  border-radius: 5px;
  ${({theme}) => theme.elevations.large};
  overflow: hidden;
`;
